/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { FluidContainer, Radio, Tag, TableROMPlayer, LargeButton, Loader, EmptyContainer, Modal } from '../../../components';
import { ARMcontext } from '../../../utils/context/context';
import {
  RadiosContainer,
  TableWrapper,
  RadiosWrapper,
  ArmRecoveryContainer,
  TextContainer,
  AlertContainer,
  AlertWrapper,
  Oval,
  ExamInfoContainer,
  ExamInfoUnit,
  NavContainerPlayers,
  ExamRadios,
  ExamTopNav,
  ArmRecoveryInfoButton,
  ArmRecoveryTop,
  ArmRecoveryInfoTitle,
  ArmRecoveryInfoSubtitle,
  ArmRecoveryInfoText,
  ArmRecoveryInfoSpan,
  ArmRecoveryInfoSection,
  ModalBottom,
  ModalBottomLabels,
  ModalTop,
} from '../styles';
import { Teams, Admin } from '../../../utils/api';
import TablePostStrengthPlayer from '../../../components/Table/TablePostStrengthPlayer';
import TableFreshStrengthPlayer from '../../../components/Table/TableFreshStrengthPlayer';
import TablePrimerPlayer from '../../../components/Table/TablePrimerPlayer';
import TablePostROMPlayer from '../../../components/Table/TablePostROMPlayer';
import { TableColumn, TableRow, TableSubHeader, TableTopHeader, TableUnit, TableBody, TableHead } from '../../../components/Table/styles';
import { ArmRecovery, ArmFatigue, ArmReadiness } from '../../../utils/constants/fatigueZonesInfo';
import { capitalizeFirstLetters } from '../../../utils/hooks/text-formatter';
import { useLocation, useNavigate } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  let initialExam = { fresh: true, post: false, primer: false };
  if (path.includes('post')) {
    initialExam = { fresh: false, post: true, primer: false };
  }
  else if (path.includes('armPrimer')) {
    initialExam = { fresh: false, post: false, primer: true };
  }
  let initialSubExam = path.includes('rom') ? { strength: false, rom: true } : { strength: true, rom: false };
  const [radioExams, useRadioExams] = useState<any>(initialExam);
  const [radio, useRadio] = useState<any>(initialSubExam);
  const [data, useData] = useState<any>([]);
  const [freshAverage, useFreshAverage] = useState<any>();
  const [postExams, usePostExams] = useState<any>();
  const [postAverage, usePostAverage] = useState<any>();
  const [primerExams, usePrimerExams] = useState<Array<object | any>>([]);
  const [primerAverage, usePrimerAverage] = useState<any>();
  const [loadingTable, setLoadingTable] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [tableUpdated, setTableUpdated] = useState(false);
  const [fatigueModal, setFatigueModal] = useState(false);
  const [modalInfo, setModalInfo] = useState<any>(initialExam.fresh ?
    ArmRecovery : initialExam.post ? ArmFatigue : ArmReadiness
  );
  const { selectedPlayer } = useContext(ARMcontext);
  const TEAMS = new Teams();
  const ADMIN = new Admin();

  useEffect(() => {
    fetchAllExams()
  }, [selectedPlayer]);

  useEffect(() => {
    let loc = location.pathname
    if (loc.substring(loc.length - 5, loc.length) === 'exams') {
      navigate("/players/exams/fresh/strength", { replace: true })
    }
  }, [])

  async function fetchAllExams() {
    await fetchPlayerSummary();
    await fetchPostExams();
    await fetchPrimerExams();
    setLoadingTable(false);
  }

  async function fetchPlayerSummary() {
    let res: object | any = {};
    res = await TEAMS.GetExamsFromPlayer(selectedPlayer._id, 'all_exams');
    if (res?.status) {
      useData(res.data?.data?.exams);
      useFreshAverage(res.data?.data?.averages);
    }
  }

  async function fetchPostExams(): Promise<void> {
    let exams = await TEAMS.GetPostExamsFromPlayer(selectedPlayer._id);
    if (exams.status) {
      usePostExams(exams.data.data.entries);
      usePostAverage(exams.data.data.summary);
      setTableUpdated(false);
    }
  }


  async function fetchPrimerExams(): Promise<void> {
    let exams = await TEAMS.GetPrimerExamsFromPlayer(selectedPlayer._id);
    if (exams.status) {
      usePrimerExams(exams.data.data.entries);
      usePrimerAverage(exams.data.data.summary);
      setTableUpdated(false);
    }
  }

  function HandleRadioExams(e: any) {
    if (e.target.id === 'fresh') {
      navigate("/players/exams/fresh/strength", { replace: true })
      useRadioExams({ fresh: true, post: false, primer: false });
      useRadio({ strength: true, rom: false });
      setModalInfo(ArmRecovery);
    } else if (e.target.id === 'post') {
      navigate("/players/exams/post/strength", { replace: true })
      useRadioExams({ fresh: false, post: true, primer: false });
      useRadio({ strength: true, rom: false });
      setModalInfo(ArmFatigue);
    } else if (e.target.id === 'primer') {
      navigate("/players/exams/armPrimer", { replace: true })
      useRadioExams({ fresh: false, post: false, primer: true });
      useRadio({ strength: true, rom: false });
      setModalInfo(ArmReadiness);
    }
  }

  function HandleRadioExamTypes(e: any): void {
    let lastSlash = String(location.pathname).lastIndexOf("/");
    let root = String(location.pathname).substring(0, lastSlash + 1)

    if (e.target.id === 'Strength') {
      navigate(root + "strength", { replace: true })
      useRadio({ strength: true, rom: false });
    } else {
      navigate(root + "rom", { replace: true })
      useRadio({ strength: false, rom: true });
    }
  }

  async function DownloadPlayerCSV(player_id: string, onlyAllData?: boolean) {
    await ADMIN.GetPlayerCSV(player_id, onlyAllData);
  }

  async function hideExam(playerId, action, table) {
    const response = await TEAMS.HideExam(playerId, action, table);
    if (response.status) {
      await fetchAllExams();
    }
    setTableUpdated(false);
  }

  function SetModalBottom(info) {
    let rows = Object.entries(info.info.zones);
    return (
      <ModalBottom>
        <ModalBottomLabels>
          {rows.map((row, rowIndex) =>
            <React.Fragment key={rowIndex}>
              <Oval size={'8'} color={row[0]} margin={'0px 8px'} />
              {capitalizeFirstLetters(row[0], ' ')}
            </React.Fragment>)}
        </ModalBottomLabels>
        <TableUnit color='black'>
          <TableHead>
            <TableRow>
              <TableTopHeader hide={true}></TableTopHeader>
              <TableTopHeader colSpan={5} color='black'>{String(info.info.title).toUpperCase()}</TableTopHeader>
            </TableRow>
            {info.info.categories && <TableRow>
              <TableSubHeader hide={true} border={'none'}></TableSubHeader>
              {info.info.categories.map(category =>
                <TableSubHeader key={category}>{category}</TableSubHeader>)}
            </TableRow>}
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) =>
              <TableRow key={rowIndex} bgColor={row[0]}>
                <TableColumn width={'0px'}><Oval size={'8'} color={row[0]} margin={'0px 8px'} /></TableColumn>
                {Object.values(Object(row[1])).map((col, colIndex) =>
                  <TableColumn key={colIndex}>{String(col)}</TableColumn>)}
              </TableRow>
            )}
          </TableBody>
        </TableUnit>
      </ModalBottom>
    )
  }

  return (
    <FluidContainer>
      <RadiosWrapper>
        <ExamTopNav>
          <EmptyContainer mWidth={'125px'} />
          <ExamRadios>
            <RadiosContainer onClick={HandleRadioExams} mBottom={'15px'}>
              <Radio
                theme="button"
                title="FRESH EXAM"
                name="radioExams"
                id="fresh"
                checked={radioExams.fresh}
                dynamicActive={radioExams.fresh}
                size={'16px'}
              />
              <Radio
                theme="button"
                title="POST EXAM"
                name="radioExams"
                id="post"
                checked={radioExams.post}
                dynamicActive={radioExams.post}
                size={'16px'}
              />
              <Radio
                theme="button"
                title="ARM PRIMER"
                name="radioExams"
                id="primer"
                checked={radioExams.primer}
                dynamicActive={radioExams.primer}
                size={'16px'}
              />
            </RadiosContainer>
          </ExamRadios>
          <NavContainerPlayers data-cy="exams-navigation">
            <LargeButton
              title={'XLSX'}
              icon={'excel'}
              lColor={'rgba(26,100,60,1)'}
              rColor={'rgba(32,114,69,1)'}
              callback={() => DownloadPlayerCSV(selectedPlayer._id)}
              xMargin={'0 0 0 auto'}
              rMargin={'0px 12px 0px 12px'}
            />
            <LargeButton
              title={'CSV'}
              icon={'excel'}
              lColor={'rgba(26,100,60,1)'}
              rColor={'rgba(32,114,69,1)'}
              callback={() => DownloadPlayerCSV(selectedPlayer._id, true)}
              xMargin={'0 0 0 auto'}
              rMargin={'0px 12px 0px 12px'}
            />
          </NavContainerPlayers>
        </ExamTopNav>
        <ExamInfoContainer>
          <ArmRecoveryContainer>
            {!(radioExams.post && radio.rom) && (
              <>
                <ArmRecoveryTop>
                  {radio.rom ? <TextContainer>ROM ALERTS</TextContainer>
                    : radioExams.fresh ? (
                      <TextContainer>ARM RECOVERY</TextContainer>
                    ) : radioExams.post ? (
                      <TextContainer>ARM FATIGUE</TextContainer>
                    ) : (
                      <TextContainer>ARM READINESS</TextContainer>
                    )}
                  {!radio.rom && <ArmRecoveryInfoButton onClick={() => setFatigueModal(true)}>i</ArmRecoveryInfoButton>}
                </ArmRecoveryTop>
                <AlertWrapper>
                  <AlertContainer>
                    <Oval size={'8'} color={'watch'} />
                    <span> Watch</span>
                  </AlertContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'warning'} />
                    <span> Warning</span>
                  </AlertContainer>
                  <AlertContainer>
                    {(!radioExams.post && !radio.rom) && <>
                      <Oval size={'8'} color={'medical'} />
                      <span> Medical</span>
                    </>}
                  </AlertContainer>
                </AlertWrapper>
              </>
            )}
          </ArmRecoveryContainer>
          {!radioExams.primer && (
            <RadiosContainer onChange={HandleRadioExamTypes}>
              <Radio title={`Strength`} name="tableInfo" id={`Strength`} checked={radio.strength} dynamicActive={radio.strength} />
              <Radio title={`Range of motion`} name="tableInfo" id={`Range of motion`} checked={radio.rom} dynamicActive={radio.rom} />
            </RadiosContainer>
          )}
          <ExamInfoUnit>
            <span>Unit of measure</span>
            {radio.strength && <Tag name={'Lbs'} theme={'Info'} />}
            {radio.rom && <Tag name={'Degrees'} theme={'Info'} />}
          </ExamInfoUnit>
        </ExamInfoContainer>
      </RadiosWrapper>
      <TableWrapper>
        {loadingTable ? (
          <div style={{ width: '100%', display: 'block', alignItems: 'center' }}>
            <Loader height="90px" />
          </div>
        ) : (
          <>
            {radioExams.fresh && (
              <>
                {radio.strength && (
                  <TableFreshStrengthPlayer
                    dataTableContent={data}
                    average={freshAverage}
                    dataCy={'exam-summary-table'}
                    fatigueZone={true}
                    setTableUpdated={setTableUpdated}
                    hideExam={hideExam}
                  />
                )}
                {radio.rom && (
                  <TableROMPlayer
                    dataTableContent={data}
                    average={freshAverage}
                    dataCy={'exam-rom-table'}
                    fatigueZone={true}
                    setTableUpdated={setTableUpdated}
                    hideExam={hideExam}
                  />
                )}
              </>
            )}
            {radioExams.post && (
              <>
                {radio.strength && (
                  <TablePostStrengthPlayer
                    player={selectedPlayer}
                    dataTableContent={postExams}
                    dataAverage={postAverage?.strength}
                    dataCy={'exam-summary-table'}
                    fatigueZone={true}
                    setTableUpdated={setTableUpdated}
                    hideExam={hideExam}
                  />
                )}
                {radio.rom && (
                  <TablePostROMPlayer
                    dataTableContent={postExams}
                    dataAverage={postAverage?.rom}
                    dataCy={'exam-summary-table'}
                    fatigueZone={false}
                    setTableUpdated={setTableUpdated}
                    hideExam={hideExam}
                  />
                )}
              </>
            )}
            {radioExams.primer &&
              <TablePrimerPlayer
                dataTableContent={primerExams}
                average={primerAverage}
                dataCy={'exam-rom-table'}
                fatigueZone={true}
                setTableUpdated={setTableUpdated}
                hideExam={hideExam}
              />}
          </>
        )}
      </TableWrapper>
      {fatigueModal && <Modal active={setFatigueModal} padding={"0"} maxWidth={"480px"} width={"80vw"} margin={'40px auto'} minWidth={"480px"}>
        <ModalTop>
          {radioExams.fresh && <>
            <ArmRecoveryInfoTitle>ARM RECOVERY</ArmRecoveryInfoTitle>
            <ArmRecoveryInfoSubtitle>Change from average (lbs)</ArmRecoveryInfoSubtitle>
            <ArmRecoveryInfoText>A change in your weekly average Fresh exam indicates your throwing arm recovery. Total arm strength decreases need to be less than
              <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>and less than<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>
              from average for each individual muscle.
              <br></br>
              <br></br>
              If total strength decreases
              <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>or more or<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>
              or more for each muscle group, you are showing signs that your recovery is less than optimal.
              Reducing pitch counts, pushing bullpens back and lower throwing intensity can help improve recovery.
              <br></br>
              <br></br>
              Recomendations:
              <ArmRecoveryInfoSection>WATCH</ArmRecoveryInfoSection>
              Reduce throwing workloads while you increase strength and evaluate recovery habits.
              <ArmRecoveryInfoSection>WARNING</ArmRecoveryInfoSection>
              Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase strength.
              <ArmRecoveryInfoSection>MEDICAL</ArmRecoveryInfoSection>
              Seek evaluation by a licensed medical professional.
            </ArmRecoveryInfoText>
          </>

          }
          {radioExams.post && <>
            <ArmRecoveryInfoTitle>ARM FATIGUE</ArmRecoveryInfoTitle>
            <ArmRecoveryInfoText>Arm Fatigue is determined by strength evaluations after high
              intensity throwing days to understand how fatigued your throwing
              arm becomes after games, bullpens, and velocity training days.
              <br></br>
              <br></br>
              The goal is to retain more than
              <ArmRecoveryInfoSpan>{' 90% '}</ArmRecoveryInfoSpan>
              of your strength from Fresh Exams
              <ArmRecoveryInfoSpan>{' (%Fresh) '}</ArmRecoveryInfoSpan>. If you cannot retain<ArmRecoveryInfoSpan>{' 90% '}</ArmRecoveryInfoSpan>
              of your Fresh strength, you may need to lower your workload and spend more time building strength and endurance.
              <br></br>
              <br></br>
              Recomendations:
              <ArmRecoveryInfoSection>WATCH</ArmRecoveryInfoSection>
              Reduce throwing workloads for your next high intensity throwing day.
              For example if strength was not retained on the game day, lower pitch counts on your next bullpen/game day/velo day, but maintain strength training.
              <ArmRecoveryInfoSection>WARNING</ArmRecoveryInfoSection>
              Reduce throwing workloads for your next high intensity throwing day.
              In addition to making adjustments to your next high intensity throwing day, you need to focus on recovery habits and strength.
              It is a good idea after a Warning to make the next day a low intensity throwing day or a complete day of rest.
            </ArmRecoveryInfoText>
          </>

          }
          {radioExams.primer && <>
            <ArmRecoveryInfoTitle>ARM READINESS</ArmRecoveryInfoTitle>
            <ArmRecoveryInfoText>A change in daily Arm Primer strength from a <ArmRecoveryInfoSpan>{' 7-day '}</ArmRecoveryInfoSpan>average indicates your pre-throwing strength status. Total primer strength decreases need to be less than
              <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>and less than<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>from the average for each individual test. If total primer strength decreases
              <ArmRecoveryInfoSpan>{' 10 lbs '}</ArmRecoveryInfoSpan>or more or<ArmRecoveryInfoSpan>{' 5 lbs '}</ArmRecoveryInfoSpan>or more for each test, you are showing signs that your pre-throwing strength is less than optimal.
              <br></br>
              <br></br>
              Combined with wellness data, evaluate how the arm feels and also note poor sleep and body soreness in deciding when to reduce pitch counts, push bullpens back and lower throwing intensity.
              Also consider programming adjustments for long-lever strength.
              <br></br>
              <br></br>
              Recomendations:
              <ArmRecoveryInfoSection>WATCH</ArmRecoveryInfoSection>
              Reduce throwing workloads while you increase strength and evaluate recovery habits.
              <ArmRecoveryInfoSection>WARNING</ArmRecoveryInfoSection>
              Skip a start, bullpen and high intensity weighted ball programming while training is intensified to increase strength.
              <ArmRecoveryInfoSection>MEDICAL</ArmRecoveryInfoSection>
              Seek evaluation by a licensed medical professional.
            </ArmRecoveryInfoText>
          </>
          }
        </ModalTop>
        <SetModalBottom info={modalInfo} />
      </Modal>}
    </FluidContainer>
  );
};
